import React, { ReactNode } from 'react';

import { Box, Stack } from '@mui/system';

import { cn } from '../lib/utils';

const AcViewWrapper = ({
  className,
  children,
  header,
  isDisabled = false
}: {
  className?: string;
  children: ReactNode;
  header?: ReactNode;
  isDisabled?: boolean;
}) => {
  return (
    <Stack
      direction="column"
      height="100%"
      className={cn(
        isDisabled &&
          "relative after:content-[''] after:absolute after:bg-white after:top-[40px] after:left-0 after:w-full after:h-full after:z-8 after:opacity-70",
        className
      )}
    >
      {header}
      <Box overflow="auto">{children}</Box>
    </Stack>
  );
};

export default AcViewWrapper;
